export default __webpack_public_path__ + "static/media/Padma_9781408352441.99b86874.jpg";